/* eslint-disable react/prop-types */
import React from "react";
import { Box, TextField, Tooltip, makeStyles } from "@material-ui/core";
import { AiOutlineWarning } from "react-icons/ai";
import { primaryColor } from "resources/constants";

const useStyles = makeStyles(() => ({
  scenarioTitleBox: {
    display: "flex",
    alignItems: "center",
    flexGrow: "1",
    justifyContent: "space-between",
    "& > :first-child": {
      flexGrow: "1",
      fontSize: "0.875rem",
      fontWeight: "bold",
    },
    "& :hover": {
      cursor: "text",
    },
  },
  alertIcon: {
    color: primaryColor,
  },
  scenarioNameContainer: {
    "& > :first-child": {
      paddingBottom: "10px",
    },
  },
  textFieldLabel: {
    color: "#545455",
  },
  smallerText: {
    fontSize: "smaller",
  },
  competitorsScenarioContainer: {
    padding: "15px",
    display: "flex",
    width: "100%",
    gap: "15px",
  },
}));

const ScenarioNameComponent = ({
  scenarioTotal,
  newScenarioName,
  setNewScenarioName,
  newScenarioComment,
  setNewScenarioComment,
  invalidName,
  invalidcharacter,
  invalidcharacterInCommment,
  tightLayout = false,
  isCompetitors = false,
}) => {
  const classes = useStyles();
  const MAX_SCENARIO_NAME_LENGTH = 60;
  const MAX_SCENARIO_COMMENT_LENGTH = 60;
  const [fieldValues, setFieldValues] = React.useState({
    name: newScenarioName?.substring(0, MAX_SCENARIO_NAME_LENGTH) || "",
    comment:
      newScenarioComment?.substring(0, MAX_SCENARIO_COMMENT_LENGTH) || "",
  });

  React.useEffect(() => {
    if (newScenarioName !== fieldValues.name)
      setFieldValues({
        ...fieldValues,
        name: newScenarioName,
      });
  }, [newScenarioName]);

  const handleFieldChange = (fieldName) => (event) => {
    if (fieldName === "name") setNewScenarioName(event.target.value);
    if (fieldName === "comment") setNewScenarioComment(event.target.value);
    setFieldValues({ ...fieldValues, [fieldName]: event.target.value });
  };

  return (
    <Box
      component="div"
      className={
        isCompetitors
          ? classes.competitorsScenarioContainer
          : classes.scenarioNameContainer
      }
    >
      <Box component="span" className={`${classes.scenarioTitleBox} `}>
        <TextField
          InputLabelProps={{
            className: classes.textFieldLabel,
          }}
          variant="outlined"
          size="small"
          label={!tightLayout && "Scenario name"}
          placeholder={
            tightLayout
              ? `Scenario name (max. ${MAX_SCENARIO_NAME_LENGTH} char.)`
              : "Scenario name"
          }
          value={fieldValues.name}
          onBlur={(event) => {
            if (isCompetitors) return;

            if (event.target.value) {
              setNewScenarioName(event.target.value);
            } else {
              setNewScenarioName(
                scenarioTotal.scenario.scenario_type_id === 3 ||
                  scenarioTotal.scenario.scenario_type_id === 1
                  ? `Copy of ${scenarioTotal.scenario.name}`
                  : `Copy of Scenario ${scenarioTotal.scenario.id}`
              );
            }
          }}
          onChange={handleFieldChange("name")}
          inputProps={{ maxLength: MAX_SCENARIO_NAME_LENGTH }}
          // These are not duplicate props but the linter detects them as so
          // eslint-disable-next-line react/jsx-no-duplicate-props
          InputProps={{
            "aria-label": "scenario name",
            endAdornment: (invalidName || invalidcharacter) && (
              <Tooltip
                title={invalidName ? "Duplicate name" : "Invalid character"}
                placement="left"
              >
                <Box component="span" className={classes.alertIcon}>
                  <AiOutlineWarning size={20} />
                </Box>
              </Tooltip>
            ),
            classes: {
              input: tightLayout && classes.smallerText,
            },
          }}
          helperText={
            !tightLayout &&
            `${MAX_SCENARIO_NAME_LENGTH -
              fieldValues.name
                .length} characters left (max. ${MAX_SCENARIO_NAME_LENGTH})`
          }
          FormHelperTextProps={{
            className: classes.textFieldLabel,
          }}
        />
      </Box>
      <Box component="span" className={`${classes.scenarioTitleBox} `}>
        <TextField
          InputLabelProps={{
            className: classes.textFieldLabel,
          }}
          variant="outlined"
          size="small"
          label={!tightLayout && "Comment"}
          placeholder={
            tightLayout
              ? `Comment (max. ${MAX_SCENARIO_COMMENT_LENGTH} char.)`
              : "Comment"
          }
          value={fieldValues.comment}
          onChange={handleFieldChange("comment")}
          inputProps={{ maxLength: MAX_SCENARIO_COMMENT_LENGTH }}
          // These are not duplicate props but the linter detects them as so
          // eslint-disable-next-line react/jsx-no-duplicate-props
          InputProps={{
            endAdornment: invalidcharacterInCommment && (
              <Tooltip title={'Invalid "," or "|" signs'} placement="left">
                <Box component="span" className={classes.alertIcon}>
                  <AiOutlineWarning size={20} />
                </Box>
              </Tooltip>
            ),
            classes: {
              input: tightLayout && classes.smallerText,
            },
          }}
          helperText={
            !tightLayout &&
            `${MAX_SCENARIO_COMMENT_LENGTH -
              fieldValues.comment
                .length} characters left (max. ${MAX_SCENARIO_COMMENT_LENGTH})`
          }
          FormHelperTextProps={{
            className: classes.textFieldLabel,
          }}
        />
      </Box>
    </Box>
  );
};

export default ScenarioNameComponent;
